var map = {
	"./AMTE.jpg": "c517",
	"./Ambilight.jpg": "50b4",
	"./Amcare.jpg": "0ec5",
	"./ArgonMedicalDevices.jpg": "b1bc",
	"./Astrall.jpg": "607e",
	"./BorchMachinery.jpg": "7c5d",
	"./CXMT.jpg": "df0f",
	"./Capcon.jpg": "8ac3",
	"./CheryHolding.jpg": "46f2",
	"./ChinaLogisticsProperty.jpg": "3358",
	"./Cloudwise.jpg": "0296",
	"./DimensionAI.jpg": "ec14",
	"./DistinctHealthcare.jpg": "7050",
	"./HFIe.jpg": "f4be",
	"./HeadSpin.jpg": "ff0f",
	"./HuayunHechuang.jpg": "d3e9",
	"./Imunopharm.jpg": "b42d",
	"./Indeni.jpg": "23ee",
	"./Lakala.jpg": "f8bd",
	"./Lauffer.jpg": "128b",
	"./Leanplum.jpg": "ecba",
	"./LenovoDCGChina.jpg": "2367",
	"./LenovoImage.jpg": "80791",
	"./Longshine.jpg": "fcc6",
	"./OmniVisionTechnologies.jpg": "2806",
	"./PINSMedical.jpg": "2256",
	"./QidiSemiconductor.jpg": "09a7",
	"./Qina.jpg": "bea5",
	"./Qumulo.jpg": "1004",
	"./REALIZE.jpg": "df27",
	"./Recilaser.jpg": "cba3",
	"./RiVAITechnology.jpg": "6970",
	"./RootnetTechnology.jpg": "234d",
	"./Sensel.jpg": "24cd",
	"./Seyond.jpg": "d042",
	"./Sinovation.jpg": "bafc",
	"./SmartYunzhou.jpg": "d065",
	"./TCabTech.jpg": "3fa8",
	"./Tengden.jpg": "98c8",
	"./Transtreams.jpg": "b4f1",
	"./TsingMicro.jpg": "a931",
	"./Vionvision.jpg": "92b1",
	"./Visionly.jpg": "9c77",
	"./Weiheng.jpg": "3665",
	"./WizRocket.jpg": "652c",
	"./WuhuShipyard.jpg": "29ea",
	"./XHPsemi.jpg": "1dbe",
	"./Yongxin.jpg": "e1b3",
	"./ZTOExpress.jpg": "fbe7",
	"./Zero2IPOGroup.jpg": "61eb",
	"./ZhongGanMicro.jpg": "c8ba2",
	"./banner.jpg": "301c",
	"./memsic.jpg": "5af4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";